// extracted by mini-css-extract-plugin
export var practice = "style-module--practice--c86ec";
export var practice_col = "style-module--practice_col--c3bbc";
export var practice_colItem = "style-module--practice_col-item--fb641";
export var practice_colItemIcon = "style-module--practice_col-item--icon--27def";
export var practice_colItemName = "style-module--practice_col-item--name--8b10a";
export var practice_row = "style-module--practice_row--a4fac";
export var practice_subtitle = "style-module--practice_subtitle--ca781";
export var practice_title = "style-module--practice_title--40d94";